module.exports = __webpack_public_path__ + "static/media/results-image2.e26f5b63.png";